var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 48,
    viewBox: "0 0 175 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 40.3393C9.98645 46.8164 17.7076 48.6309 28.6599 46.8393C45.7938 44.0365 43.3386 21.5501 59.3372 14.8393C77.4767 7.23051 90.2508 21.8031 109.628 18.3393C126.356 15.3491 133.611 -3.11414 149.86 1.83929C164.435 6.28226 164.573 20.4283 174 32.3393",
    stroke: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave);
export default __webpack_public_path__ + "static/media/wave.c45b5ef6e611e841c3b660da4992c785.svg";
export { ForwardRef as ReactComponent };